import { Box, Skeleton, Stack } from '@mui/material';
import React from 'react';

export interface ChatMessageBubbleSkeletonProps {
  align: 'left' | 'right';
}

const ChatMessageBubbleSkeleton: React.FC<ChatMessageBubbleSkeletonProps> = ({
  align,
}) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: align === 'right' ? 'flex-end' : 'flex-start',
      width: '100%',
    }}
  >
    <Box
      sx={{
        maxWidth: '85%',
        borderRadius: 2,
        px: 1.5,
        py: 1.25,
        backgroundColor: 'grey.100',
        border: 1,
        borderColor: 'divider',
      }}
    >
      <Stack spacing={0.75}>
        <Skeleton
          variant="text"
          width={120}
          height={12}
          sx={{ flexShrink: 0 }}
        />
        <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 1 }}>
          <Skeleton variant="text" width={160} height={18} sx={{ flex: 1 }} />
          <Skeleton
            variant="text"
            width={28}
            height={12}
            sx={{ flexShrink: 0 }}
          />
        </Box>
      </Stack>
    </Box>
  </Box>
);

export default ChatMessageBubbleSkeleton;
